import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import { ConversationThreadFragment } from './fragments';
import {
  ImageEmbedFieldsFragment,
  PostUploadConfigFieldsFragment,
} from '../imageEmbed/fragments';

export const CONVERSATION_THREAD_COMMENT_ADD = gql`
  mutation ConversationThreadCommentAdd($input: ThreadCommentAddInput!) {
    conversationThreadCommentAdd(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;

export const CONVERSATION_THREAD_READ = gql`
  mutation ConversationThreadRead($input: ThreadReadInput!) {
    conversationThreadRead(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;

export const CONVERSATION_THREAD_START = gql`
  mutation ConversationThreadStart($input: ThreadStartInput!) {
    conversationThreadStart(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;

export const CONVERSATION_THREAD_RESOLVE = gql`
  mutation ConversationThreadResolve($input: ThreadResolveInput!) {
    conversationThreadResolve(input: $input) {
      errors {
        ...ErrorFields
      }
      resolved
    }
  }
  ${ErrorFragment}
`;

export const CONVERSATION_THREAD_COMMENT_IMAGE_EMBED_ADD = gql`
  mutation ConversationThreadCommentImageEmbedAdd {
    conversationThreadCommentImageEmbedAdd {
      errors {
        ...ErrorFields
      }
      uploadConfig {
        imageEmbed {
          ...ImageEmbedFields
        }
        postUploadConfig {
          ...PostUploadConfigFields
        }
      }
    }
  }
  ${ErrorFragment}
  ${ImageEmbedFieldsFragment}
  ${PostUploadConfigFieldsFragment}
`;

export const CONVERSATION_THREAD_COMMENT_UPDATE = gql`
  mutation ConversationThreadCommentUpdate($input: ThreadCommentUpdateInput!) {
    conversationThreadCommentUpdate(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;

export const CONVERSATION_THREAD_COMMENT_DELETE = gql`
  mutation ConversationThreadCommentDelete($input: ThreadCommentDeleteInput!) {
    conversationThreadCommentDelete(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;

export const COMMENT_REACTION_ADD = gql`
  mutation CommentReactionAdd($input: CommentReactionAddInput!) {
    conversationCommentReactionAdd(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;

export const COMMENT_REACTION_REMOVE = gql`
  mutation CommentReactionRemove($input: CommentReactionDeleteInput!) {
    conversationCommentReactionDelete(input: $input) {
      errors {
        ...ErrorFields
      }
      thread {
        ...ConversationThreadFields
      }
    }
  }
  ${ErrorFragment}
  ${ConversationThreadFragment}
`;
